import React from 'react';
import { ApolloProvider } from '@apollo/client';
import client from '../lib/apolloClient';
import WizardOverlay from '../components/UnifiedIntake/WizardOverlay';

class UnifiedIntakeContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false, showConfirm: false };
    this._handler = this._handler.bind(this);
    this._confirmYes = this._confirmYes.bind(this);
    this._confirmNo = this._confirmNo.bind(this);
  }

  _handler() {
    // Intercept the open event and show a pre-confirmation modal first
    this.setState({ showConfirm: true });
  }

  _confirmYes() {
    this.setState({ showConfirm: false, open: true });
    try { document.documentElement.classList.add('intake-overlay-active'); } catch (_) {}
  }

  _confirmNo() {
    this.setState({ showConfirm: false });
  }

  componentDidMount() {
    window.addEventListener('open-unified-intake', this._handler);
  }

  componentWillUnmount() {
    window.removeEventListener('open-unified-intake', this._handler);
  }

  render() {
    return (
      <ApolloProvider client={client}>
        {this.state.showConfirm && (
          <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="absolute inset-0 bg-black/50" />
            <div className="relative mx-4 max-w-xl w-full rounded-xl border border-succession-border bg-succession-bg-primary text-succession-text-primary shadow-2xl">
              <div className="p-6">
                <h2 className="text-xl font-semibold mb-2">Value & Readiness Assessment</h2>
                <p className="text-succession-text-secondary">
                  This 5‑minute guided assessment surfaces your key value and readiness gaps. You’ll get essential metrics and a prioritized master action plan broken into sprints.
                </p>
                <p className="mt-4 font-medium">Ready to proceed?</p>
                <div className="mt-5 flex flex-col sm:flex-row gap-3 sm:justify-end">
                  <button type="button" className="px-5 py-2.5 rounded-md bg-succession-primary text-white hover:bg-succession-primary/90" onClick={this._confirmYes}>
                    Yes, take assessment
                  </button>
                  <button type="button" className="px-5 py-2.5 rounded-md border border-succession-border text-succession-text-secondary hover:bg-succession-bg-secondary" onClick={this._confirmNo}>
                    No, maybe later
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <WizardOverlay
          isOpen={this.state.open}
          onClose={() => {
            this.setState({ open: false });
            try { document.documentElement.classList.remove('intake-overlay-active'); } catch (_) {}
          }}
        />
      </ApolloProvider>
    );
  }
}

export default UnifiedIntakeContainer;


